module.exports=function(scope){ return `<!-- Liveness passed -->
{
    "data": {
        "glasses": false,
        "faceMapType": 0,
        "ageResult": 4,
        "livenessStatus": 0,
        "auditTrailVerificationCheck": true,
        "message": "The 3D FaceMap evaluated and Liveness was proven.",
        "isLowQuality": false,
        "tid": "...",
        "auditTrailMatchCheck": true,
        "isReplayFaceMap": true
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The 3D FaceMap evaluated and Liveness was proven."
    }
}


<!-- Liveness Could Not Be Determined, Retry Required -->
{
    "data": {
        "glasses": false,
        "faceMapType": 0,
        "livenessStatus": 1,
        "auditTrailVerificationCheck": true,
        "message": "The 3D FaceMap evaluated and Liveness was not proven.  The developer should prompt the user with retry guidance as demonstrated in the Device SDK Sample Apps.",
        "isLowQuality": false,
        "tid": "...",
        "auditTrailMatchCheck": false,
        "isReplayFaceMap": true
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The 3D FaceMap evaluated and Liveness was not proven.  The developer should prompt the user with retry guidance as demonstrated in the Device SDK Sample Apps."
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/liveness.json.tpl